"use strict";
angular.module("newCreatEventModule", [])
    .controller("newCreatEventCtrl", ["$scope", "$rootScope", "$modalInstance", "localStorageService", "$sce", "trsHttpService", "modalDialog", "$timeout", "$compile", "commandService", "$q","createEventI", "$validation", "$filter","trsspliceString",
        function($scope, $rootScope, $modalInstance, localStorageService, $sce, trsHttpService, modalDialog, $timeout, $compile, commandService , $q,createEventI, $validation,$filter, trsspliceString) {
            initStatus();
            initData();
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    creatInitStatus: false,
                    showInitTheme: false,
                    createTitle:angular.isDefined(createEventI.item)==""?"新建事件":"编辑事件",
                    optionNull:'',
                    slaveidsArr:[],
                    eventSonInfo:[],
                    editStatus:false,
                };
                //事件话题
                $scope.eventParams = {
                    type: 1,
                    typeid: 'event',
                    eventtype: 'public',
                    title: '',
                    keywordsinclude: [],//包含全部关键词
                    keywordseitheror: [],//包含任意关键词
                    keywordsexclusive: [],//不包含关键词
                    slaveids:''
                };
                //事件子话题
                $scope.eventSonParams = {
                    type: 2,
                    typeid: 'event',
                    eventtype: 'public',
                    title: '',
                    position:0,
                    keywordsinclude: [],//包含全部关键词
                    keywordseitheror: [],//包含任意关键词
                    keywordsexclusive: []//不包含关键词
                };
                //获取事件信息
                $scope.eventInfoParams={
                    type: 1,
                    typeid: 'event',
                    eventtype: 'public',
                    eventid:'',
                };
                //获取子话题信息
                $scope.eventSonInfoParams={
                    type: 2,
                    typeid: 'event',
                    eventtype: 'public',
                    eventid:'',
                };
                //子话题更新
                $scope.eventSonNewParams={
                    type: 3,
                    typeid: 'event',
                    eventtype: 'public',
                    eventid:0,
                    slaveid:'',
                };
                $scope.eventOptionsPos = [
                    {name: '全部', value: 0},
                    {name: '标题', value: 1},
                    {name: '正文', value: 2}
                ];
                $scope.eventOptionsPosCh=angular.copy($scope.eventOptionsPos[0]);
            }
            /**
             * [initCreate description] 初始化新建数据
             * @return {[type]} [description]
             */
            function initData() {
                    initCreate();
                    initEdit();
            }
            function initCreate() {
                $scope.status = {
                    keywordsArray: [{ keywords: [],name:'包含全部',value:"keywordsinclude" }],
                    sonKeywordsArr: [{ keywords: [],name:'包含全部',value:"keywordsinclude"}]
                };
            }
            //父话题增加条目
            $scope.addEventKeyWords = function() {
                getkeyswordsSelect($scope.status.keywordsArray);
            };
            //子话题中增加条目
            $scope.haveEventKeyWords = function() {
                getkeyswordsSelect($scope.status.sonKeywordsArr);
            };
            function getkeyswordsSelect(keywordsArr){
                if(!(keywordsArr instanceof Array)) keywordsArr=[];
                if(keywordsArr.length<3){
                    if(keywordsArr.length==1){
                        keywordsArr.push({ keywords: [],name:"包含任意",value:"keywordseitheror" });
                    }else if(keywordsArr.length==2){
                        angular.forEach(keywordsArr, function (item,key) {
                            if(item.value==="keywordseitheror"){
                                keywordsArr.push({ keywords: [],name:"不包含",value:"keywordsexclusive"  });
                            }else if(item.value==="keywordsexclusive"){
                                keywordsArr.splice(1,0,{ keywords: [],name:"包含任意",value:"keywordseitheror" });
                            }
                        });
                    }
                    return keywordsArr;
                }
            }
            //删除话题条目
            $scope.delEventKeyWords = function(index) {
                $scope.status.keywordsArray.splice(index,1);
            };
            $scope.delEventKeyWordson = function(index) {
                $scope.status.sonKeywordsArr.splice(index, 1);
            };
            $scope.selectKeyWordPo=function(data){
                $scope.eventSonParams.position=data.value;
            };
            //显示子话题包含信息
            $scope.showEventSonKeyword=function(index){
                $scope.showIndex=index;
            };
            //隐藏子话题包含信息
            $scope.hideEventSonKeyword=function(index){
                $scope.showIndex=-1;
            };
            //编辑子话题
            $scope.editSonEvent=function(item){
                $scope.data.creatInitStatus = true;
                $scope.data.editStatus=true;
                $scope.eventSonParams.title=item.TITLE;
                if(createEventI.item){
                    $scope.eventSonParams.eventid=item.EVENTID;
                    $scope.eventSonParams.slaveid=item.ID;
                }else{
                    $scope.eventSonParams.eventid=0;
                    $scope.eventSonParams.type=3;
                    $scope.eventSonParams.slaveid=item.ID;
                }
                $scope.status.sonKeywordsArr=[];
                getKeywordsData(item,$scope.status.sonKeywordsArr);
            }
            //删除事件分析
            $scope.deleteSonEvent=function(item,index){
                var params={
                    typeid: "widget",
                    serviceid: "eventmgr",
                    modelid: "deleteslave",
                    incidentid:item.ID
                };
                modalDialog.confirmModal("删除提示", "是否确认删除？",function() {
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "GET").then(function(data) {
                        if(data){
                            modalDialog.alertType('删除成功', '', 'success', false, function() {
                                if(!angular.isUndefined(createEventI.item)){
                                    getSonInfoData().then(function(data){
                                        angular.forEach($scope.data.eventSonInfo, function (key, value) {
                                            if (key.ID === item.ID) {
                                                $scope.data.eventSonInfo.splice(value, 1);
                                            }
                                        });
                                    });
                                }else{
                                    $scope.data.eventSonInfo.splice(index, 1);
                                }
                            });
                        }else{
                            modalDialog.alertType('删除失败', '', 'error', false, function() {});
                        }
                    });
                }, function(){
                    return;
                });
            };
            /**
             * [initEdit description] 获取子话题数据
             * @return {[type]} [description]
             */
            function getSonInfoData(){
                var defer=$q.defer();
                $scope.eventSonInfoParams.eventid=createEventI.item.ID;
                $scope.eventSonParams.eventid=createEventI.item.ID;
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventSonInfoParams, "GET").then(function(data) {
                    if(angular.isDefined(data)){
                        $scope.data.eventSonInfo=data;
                        defer.resolve(data);
                    }
                });
                return defer.promise;
            }
            /**
             * [initEdit description] 初始化编辑数据
             * @return {[type]} [description]
             */
            function initEdit() {
                if(angular.isDefined(createEventI.item)){
                    $scope.eventInfoParams.eventid=createEventI.item.ID;
                    $scope.eventParams.eventid=createEventI.item.ID;
                    getSonInfoData();
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventInfoParams, "GET").then(function(data) {
                        if(angular.isDefined(data)){
                            $scope.eventParams.title=data.TITLE;
                            $scope.eventParams.starttime=$filter('date')(new Date(data.STARTTIME), "yyyy-MM-dd").toString();
                            $scope.eventParams.endtime=$filter('date')(new Date(data.TERMINALTIME), "yyyy-MM-dd").toString();
                            $scope.status.keywordsArray=[];
                            getKeywordsData(data,$scope.status.keywordsArray);
                        }
                    });
                };
            }
            function getKeywordsData(data,initArray){
                if(data.KEYWORDSINCLUDE !=''){
                    initArray.push({ keywords: data.KEYWORDSINCLUDE.split(" "),name:"包含全部",value:"keywordsinclude" });
                }
                if(data.KEYWORDSEITHEROR !=''){
                    initArray.push({ keywords: data.KEYWORDSEITHEROR.split(" ") ,name:"包含任意" ,value:"keywordseitheror"});
                }
                if(data.KEYWORDSEXCLUSIVE !=''){
                    initArray.push({ keywords: data.KEYWORDSEXCLUSIVE.split(" ") ,name:"不包含",value:"keywordsexclusive" });
                }
                return initArray;
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            $scope.creatInitTheme = function() {
                $scope.data.editStatus=false;
                $scope.data.creatInitStatus = true;
            }
            //子话题保存
            $scope.sonsave = function() {
                if($scope.status.sonKeywordsArr!=''){
                    angular.forEach($scope.status.sonKeywordsArr,function(value,key){
                        $scope.eventSonParams[value.value] =  value.keywords.join(";");
                    })
                }
                $scope.creatEventForm.$pending = {};
                $validation.validate($scope.creatEventForm).success(function() {
                    if($scope.eventSonParams.keywordsinclude==''&&$scope.eventSonParams.keywordseitheror==''&&$scope.eventSonParams.keywordsexclusive==''){
                        modalDialog.alertType('子话题三类关键词至少有一个', '', 'info', false);
                        return;
                    }
                    if($scope.data.editStatus){
                        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventSonParams, "POST").then(function(data) {
                            if(angular.isDefined(data)){
                                modalDialog.alertType('编辑成功', '', 'success', false, function() {
                                    $scope.eventSonInfoParams.eventid=createEventI.item.EVENTID;
                                    $scope.eventParams.slaveids=data;
                                     getSonInfoData();
                                });
                            }

                        });
                    }else{
                        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventSonParams, "post").then(function(data) {
                            if(data!=''){
                                var datas=data.trim();
                                $scope.eventSonNewParams.slaveid=datas;
                                $scope.data.slaveidsArr.push(datas);
                                $scope.eventParams.slaveids=$scope.data.slaveidsArr.join(";");
                                modalDialog.alertType('新建成功', '', 'success', false, function() {
                                    if(createEventI.item==undefined){
                                        sonEventNewRe();
                                    }else{
                                        $scope.eventSonInfoParams.eventid=createEventI.item.EVENTID;
                                        getSonInfoData();
                                    }
                                });
                                $scope.eventSonParams.title='';
                                $scope.status.sonKeywordsArr=[{ keywords: [],name:"包含全部",value:"keywordsinclude" }];
                            }
                        });
                    }
                    $scope.data.creatInitStatus = false;
                  }).error(function() {

                });
            };
            //新建时的子话题更新
            function sonEventNewRe(){
                //获取子话题未新建时的信息
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventSonNewParams, "GET").then(function(data) {
                    if(angular.isDefined(data)){
                        angular.forEach($scope.data.eventSonInfo, function (key, value) {
                            if (key.ID === data.ID) {
                                $scope.data.eventSonInfo.splice(value, 1);
                            }
                        });
                        $scope.data.eventSonInfo.push(data);
                    }
                });
            }
            //子话题放弃保存
            $scope.songaveup = function() {
                $scope.data.creatInitStatus = false;
                $scope.eventSonParams.title='';
                $scope.status.sonKeywordsArr=[{ keywords: [],name:"包含全部",value:"keywordsinclude" }];
            };
            //关闭弹窗
            $scope.close = function() {
                $modalInstance.dismiss();
            };
            //提交事件
            $scope.confirm = function() {
                if($scope.status.keywordsArray!=''){
                    angular.forEach($scope.status.keywordsArray,function(value,key){
                        $scope.eventParams[value.value] =  value.keywords.join(";");
                    })
                }
                $scope.creatEventForm.$pending = {};
                $validation.validate($scope.creatEventForm).success(function() {
                    if($scope.eventParams.keywordsinclude==''&&$scope.eventParams.keywordseitheror==''&&$scope.eventParams.keywordsexclusive==''){
                        modalDialog.alertType('三类关键词至少有一个', '', 'info', false);
                        return;
                    }
                    if($scope.data.creatInitStatus){
                        modalDialog.alertType('子话题未保存', '', 'info', false);
                        return;
                    }
                    if(!angular.isUndefined(createEventI.item)){
                        getSonInfoData().then(function(data){
                            $scope.eventParams.slaveids=trsspliceString.spliceString(data, "ID", ";");
                        });
                    }
                    modalDialog.confirmModal($scope.data.createTitle+"提示", "是否"+$scope.data.createTitle+"？",function() {
                        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventParams, "post").then(function(data) {
                            if(data.ISSUCCESS){
                                modalDialog.alertType($scope.data.createTitle+'成功', '', 'success', false, function() {
                                    $rootScope.$broadcast("addNewEventChange", {operation:$scope.data.createTitle});
                                    $modalInstance.close();
                                });
                            }else{
                                modalDialog.alertType(data, '', 'error', false, function() {
                                    $modalInstance.close();
                                });
                            }
                        });
                    }, function(){
                        return;
                    });
                }).error(function() {
                    modalDialog.alertType('请检查填写项', '', 'error', false, function() {
                        return;
                    });
                });
            };

        }
    ]);